// src/utils/geoUtils.js

/**
 * 2点間のハバーサイン距離を計算する（km）
 *
 * @param {number} lat1 - 地点1の緯度（度）
 * @param {number} lng1 - 地点1の経度（度）
 * @param {number} lat2 - 地点2の緯度（度）
 * @param {number} lng2 - 地点2の経度（度）
 * @returns {number} 距離（km）
 */
export const haversineDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // 地球半径（km）
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

/**
 * 現在地から半径 radiusKm 以内に存在するスポットを返す
 *
 * @param {{ lat: number, lng: number }} userLocation - 現在地座標
 * @param {Array<{ id: string, lat: number, lng: number }>} spots - 全スポット一覧
 * @param {number} [radiusKm=5] - 検索半径（km）
 * @returns {Array<{ id: string, lat: number, lng: number }>} 半径内のスポット一覧
 */
export const findSpotsWithinRadius = (userLocation, spots, radiusKm = 5) => {
  return spots.filter(
    (spot) =>
      haversineDistance(userLocation.lat, userLocation.lng, spot.lat, spot.lng) <=
      radiusKm
  );
};
